export default __webpack_public_path__ + "static/media/profileSample.f27ef04e.jpg";